import React, { useState } from "react";
import { Modal, Image, Form, Row, Col, Button } from "react-bootstrap";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useSelector } from "react-redux";


const Filter = (props) => {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [state, setState] = useState({
    category: "",
    type: "",
    start: "",
    end: ""
  });
  const selecthandleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const cat = useSelector((state) => {
    return state.categories?.get_all_categories || [];
  });

  const onFilterApply = () => {
    props.onFilter(state);
    onCloseModal()
  }

  const onCancleModal = () => {
    setState({
      category: "",
      type: "",
      start: "",
      end: ""
    });
    onCloseModal()
  }

  return (
    <React.Fragment>
      <div
        onClick={onOpenModal}
        className="d-flex align-items-center justify-content-between cursor"
      >
        <Image
          alt="filter"
          title="filter"
          width="80px"
          src={require("../../../assets/images/seatingImages/filter.svg")}
        />
        {/* <div className="f12-500 text-blue mx-2">Filter</div>
        <i className="fa fa-angle-down text-blue" aria-hidden="true"></i> */}
      </div>
      <Modal show={open} onHide={onCloseModal} centered>
        <Modal.Header className="border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6} className="pb-4">
                <TextField
                  id="start_date"
                  label="Start Date"
                  variant="outlined"
                  type="date"
                  className="w-100"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="start"
                  value={state.start}
                  onChange={selecthandleChange}
                />
              </Col>
              <Col md={6} className="pb-4">
                <TextField
                  id="end_date"
                  label="End Date"
                  variant="outlined"
                  type="date"
                  className="w-100"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="end"
                  value={state.end}
                  onChange={selecthandleChange}
                />
              </Col>
              <Col md={12} className="pb-4">
                <FormControl variant="outlined" className={"w-100"}>
                  <InputLabel htmlFor="outlined-Request">
                    Issue Category
                  </InputLabel>
                  <Select
                    value={state.category}
                    onChange={selecthandleChange}
                    label="Request Type"
                    inputProps={{
                      name: "category",
                      id: "outlined-Request",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {cat.map(ele => <option value={ele._id} key={ele._id}>{ele.title}</option>)}
                  </Select>
                </FormControl>
              </Col>
              <Col md={12} className="pb-4">
                <FormControl variant="outlined" className={"w-100"}>
                  <InputLabel htmlFor="outlined-status">Issue Type</InputLabel>
                  <Select
                    value={state.type}
                    onChange={selecthandleChange}
                    label="Status"
                    inputProps={{
                      name: "type",
                      id: "outlined-Request",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <option value={"ISSUE"}>Issue</option>
                    <option value={"SUGGESTION"}>Suggestion</option>
                  </Select>
                </FormControl>
              </Col>
            </Row>
            <div className="pt-4 d-flex align-items-center">
              <Button
                variant="outline-secondary"
                className="btn150px btn-lg mr-4 px-5"
                onClick={onCancleModal}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                className="btn150px btn-lg px-5"
                onClick={onFilterApply}
              >
                Apply
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default Filter;
